import { Dispatch, SetStateAction, createContext } from 'react'

interface IContextProps {
    setChargesInputs: Dispatch<SetStateAction<ChargesInputs>>
    chargesInputs: ChargesInputs
    loader: { GET_CARD_ACQUIRING_CHARGES: boolean | null }
    charges: ICharges
}

export const Context = createContext({} as IContextProps)
